import {config} from '../app/config';
import {betragToString} from "./utils";

export class Texte {
  constructor(public environment: any) {
  }

  hinweisEinverstaendniserklaerungJugend() {
    return `Bitte die <a href="${this.environment.appHost}/assets/download/U18_Erklaerung.pdf" class="alert-link" target="_blank">
Einverständniserklärung für Reiseteilnehmer unter 18 Jahren</a> ausfüllen und mitbringen!`;
  }

  hinweiseGuiding() {
    return 'Guiding: Durchführung ab 4 Personen und Abrechnung direkt mit dem Guide (Reisekosten für den Guide geteilt durch Teilnehmer).';
  }

  hinweisGuthaben(guthaben: number) {
    const guthabenStr = betragToString(guthaben);
    return `Das vorhandene Guthaben von ${guthabenStr} kann zur Bezahlung von Reisen verwendet werden.
Zur Auszahlung bitte Kontakt aufnehmen.`;
  }

  hinweisZahlung() {
    return `Die Anzahlung (50%, bei Tagesreisen 100%) darfst Du acht Wochen vor Reisebeginn begleichen.
Falls Du Dich auf der Nachrückerliste befindest ist keine Zahlung möglich, erst nachdem die Buchung von uns
angenommen und bestätigt wurde.
Die Restzahlung ist zwei Wochen vor Reisebeginn fällig.
Nach Zahlungseingang gilt die Reise als gebucht, Du erhältst eine Bestätigung.
Die Anzahlung dient als Stornosicherung. Bei fristgerechter Stornierung
erhältst Du Deine Anzahlung zurück. Wir erlauben uns aber in jedem Fall eine
Bearbeitungspauschale von ${betragToString(config.bearbeitungspauschale)} einzubehalten.
Sollte nach einer Frist von 3 Tagen die Zahlung nicht eingegangen sein werden
wir dich nochmal erinnern, danach verfällt Deine Buchungsanfrage.
Die Zahlung ist online möglich per PayPal sowie im Shop per EC und Bar.
`;
  }

  hinweisBorderReiseMitPartyCharakter() {
    return 'Mir ist bewusst, dass ich eine Boarder-Reise mit Party Charakter buche, mit überhöhter Lautstärke ist zu rechnen.';
  }

  hinweisVermittlung() {
    return 'Darwins Reisen vermittelt Reisen die von der Firma <a href="https://www.friedel-reisen.de/" target="_blank">Friedel Reisen GbR</a> durchgeführt werden.' +
      ' Der Kunde akzeptiert deren <a href="https://www.friedel-reisen.de/Services" target="_blank">Reisebedingungen und Stornokosten</a>.' +
      ' Wir empfehlen den Abschluss einer Reiserücktrittskostenversicherung.';
  }

  hinweisCoronaRegelungen() {
    return 'Mit der Reisebuchung akzeptieren Sie die ges. Anordnungen/Anforderungen zur Eindämmung der Covid-Pandemie, welche zum Zeitpunkt der Reise für die Reise notwendig sein wird.';
  }
}
